//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var costInfo;
var dateOccu;
var costType;
import SlipDel from 'vue-slip-delete';
import { createCostInfo, costTypeSelectList, costTypeSelect, saveCost, insertCost, uploadCostImg, selectDictionType, selectFillList, FILE_URL } from '@/api/rem/cost/cost';
import { DORM } from "@/config/constant"
import promise from '@/axios/promise'

// import {formatXml} from '@/common/a'
export default {
	inject: ['reload'],
	components: {
		SlipDel
	},
	data() {
		return {
			data: {
				userType: '',
				date: undefined,
				atypeText: '',
				costType: '',
				costDate: '',
				options: ['暂未获取到任何数据'],
				dateOccu: '',
				amouMone: '',
				infoFid: '',
				imgUrl: '',
				costIcon: '',

			},
			solo: true,
			alert: false,
			exendFrom: {},
			imgList: [],
			datas: new FormData(),
			files: 0,
			size: 0,
			costTypeOptions: ['暂未获取到任何数据'],
			fillList: [],
			fillcreate: {
				fillType: 'A',
				fillCode: '',
				fillNumb: '',
				fillMone: '',
				fillTime: '',
				fillImg: '',
				fillImgUrl: ''
			},
			costTypeList: [],
			costTypefield: [],
			file_URL: '',
		}
	},
	created() {
		if(this.$route.query.costData != undefined) {
			dateOccu = this.$route.query.costData.dateOccu;
			this.data = this.$route.query.costData;
			console.log(this.data);
			costType = this.data.costType
			console.log('imgurl')
			console.log(this.data.imgUrl)
			if(this.data.imgUrl != '' && this.data.imgUrl != null) {
				this.data.imgUrl = this.data.imgUrl.split(',');

			}
		}
		this.getData();
		var creaDate = this.data.costDate;
		this.data.costDate = creaDate.slice(0, 19)
		var fillMainId = {
			'mainId': this.data.infoFid
		}
		selectFillList(fillMainId).then(res => {
			this.fillList = res;
		})
		// console.log('于2018年10月29完结')
		promise({
			url: DORM + "/expense/selectDictionType",
			method: "get",
			async: false,
			params: {
				type: "fileUrl"
			}
		}).then(res => {
			console.log(res);
			this.file_URL = res[0].dicCode
		});

	},
	mounted() {
		this.$previewRefresh();
		// $('.formDate').datetimepicker({
		//                  language:  'zh-CN',
		//                  weekStart: 1,
		//                  todayBtn:  1,
		//                  autoclose: 1,
		//                  todayHighlight: 1,
		//                  startView: 2,
		//                  minView: 2,
		//                  forceParse: 0
		//                  });
		// $(".formDate").datetimepicker("setDate", new Date(dateOccu));
		this.costSelectLoad(costType);

	},
	methods: {
		//弹出框
		closeAlert() {
			this.alert = false;
		},
		callBack() {
			this.$router.push({
				path: '/app/remb/costList'
			})
		},
		getData: function() {
			costTypeSelectList().then(response => {
				console.log(response)
				var json = [];
				for(var i = 0; i < response.data.length; i++) {
					var j = '';
					j = response.data[i].costName;
					json.push(j);
				}
				this.costTypeOptions = json;
			});
		}, //保存
		costSelectLoad(costType) {
			var info = {
				'Fid': costType
			};
			var _this = this;
			costTypeSelect(info).then(response => {
				//sample 文本框
				//single 单选框
				//Number 数字名称
				//provincesCities 省市框
				//Multiline 多行文本框
				//multiSelect 多选文本
				//times 日期框
				//dormitory 宿舍框
				this.costTypefield = [];
				this.costTypeList = response.costTypeMinor;
				for(var i = 0; i < response.costTypeMinor.length; i++) {
					if(response.costTypeMinor[i].fielType == "single" || response.costTypeMinor[i].fielType == "multiSelect") {
						if(response.costTypeMinor[i].fielType == "multiSelect") {
							console.log(this.data)
							var prinConc1 = response.costTypeMinor[i].prinConc;
							var prinConctoLowerCase1 = prinConc1.toLowerCase()
							var prinConcSplict1 = prinConctoLowerCase1.split('_')
							for(var k = 1; k < prinConcSplict1.length; k++) {
								prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
							}
							var prinConcData = this.data[prinConcSplict1.join('')];
							console.log(prinConcData);
							var extend = response.costTypeMinor[i].extend;
							if(prinConcData != null) {
								var field = {
									field: response.costTypeMinor[i].prinConc,
									'value': prinConcData.split(','),
									'extend': extend.split(';')
								};
								this.costTypefield.push(field)
							} else {
								var field = {
									field: response.costTypeMinor[i].prinConc,
									'value': '',
									'extend': extend.split(';')
								};
								this.costTypefield.push(field)
							}

						} else {
							console.log(this.data)
							var prinConc1 = response.costTypeMinor[i].prinConc;
							var prinConctoLowerCase1 = prinConc1.toLowerCase()
							var prinConcSplict1 = prinConctoLowerCase1.split('_')
							for(var k = 1; k < prinConcSplict1.length; k++) {
								prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
							}
							var prinConcData = this.data[prinConcSplict1.join('')];
							console.log(prinConcData);
							var extend = response.costTypeMinor[i].extend;
							var field = {
								field: response.costTypeMinor[i].prinConc,
								'value': prinConcData,
								'extend': extend.split(';')
							};
							this.costTypefield.push(field)
						}

					} else if(response.costTypeMinor[i].fielType == "dataDiction") {
						var extend1 = response.costTypeMinor[i].extend;
						var info = {
							'type': extend1
						}
						var index = i;
						var _this = this;
						var arr = [];
						promise({
							url: DORM + "/expense/selectDictionType",
							method: "get",
							async: false,
							params: {
								type: extend1
							}
						}).then(res => {
							console.log(res);
							if(res.length != 0) {
								for(var K = 0; K < res.length; K++) {
									var file = res[K].dicName;
									arr.push(file)
								}

							}
						});
						var prinConc1 = response.costTypeMinor[i].prinConc;
						var prinConctoLowerCase1 = prinConc1.toLowerCase()
						var prinConcSplict1 = prinConctoLowerCase1.split('_')
						for(var k = 1; k < prinConcSplict1.length; k++) {
							prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
						}
						var prinConcData = this.data[prinConcSplict1.join('')];
						var field = {
							field: response.costTypeMinor[index].prinConc,
							'value': prinConcData,
							'extend': arr
						};
						_this.costTypefield.push(field)
					} else {
						var prinConc1 = response.costTypeMinor[i].prinConc;
						var prinConctoLowerCase1 = prinConc1.toLowerCase()
						var prinConcSplict1 = prinConctoLowerCase1.split('_')
						for(var k = 1; k < prinConcSplict1.length; k++) {
							prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
						}
						var prinConcData = this.data[prinConcSplict1.join('')];
						var field = {
							field: response.costTypeMinor[i].prinConc,
							'value': prinConcData,
							'extend': []
						};
						this.costTypefield.push(field)
					}

				}
				console.log(this.costTypefield)
				costInfo = response;
				console.log(response)
				this.data.costIcon = response.costIcon;
				// console.log(_this.data.costIcon)
			});
		},
		fileDel(index) {
			this.data.imgUrl.splice(index, 1);
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/seeCost.vue